/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { GlobalStyle } from 'styles/global-styles';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { useTranslation } from 'react-i18next';
import MainScreen from './pages/MainScreen';
import Layout from './components/Layout';
import CancelPage from './pages/Cancel';
import SuccessPage from './pages/Success';
import ErrorPage from './pages/Error';
import DeclinePage from './pages/Decline';
import ReceivedPage from './pages/Received';
import DomesticCardErrorPage from './pages/DomesticCardError';
import ConfirmPage from './pages/Confirm';
import FormSubmit from './pages/FormSubmit';
import FailedPage from './pages/Failed';
import ProcessingPage from './pages/Processing';
import PendingPage from './pages/Pendding';
import QRPage from './pages/QRCode';
import ClosePage from './pages/Close';
import PaymentPage from './pages/Payment';
import DirectPaymentPage from './pages/DirectPayment';
import DirectQRPage from './pages/DirectQR';
import DirectPendingPage from './pages/DirectPending';
import DirectIframePage from './pages/DirectIframe';
import IframePopupPage from './pages/IframePopup';
import DirectResultPage from './pages/DirectResult';
import VbankPendingPage from './pages/VbankPendding';
import DataFormSubmitPage from './pages/DataFormSubmit';
import ReturnUrlErrorPage from './pages/ReturnUrlError';
import DirectPopupPage from './pages/DirectPopup';
import UIIframePage from './pages/UiIframe';
import EchoQRPage from './pages/EchoQrCode';
import DirectEchoQRPage from './pages/DirectEchoQR';
import WechatResult from './pages/WechatResult';

import WechatOpen from './pages/WechatOpen';
import ResultConfirm from './pages/ResultConfirm';
import RedirectPage from './pages/RedirectPage';
import TestPage from './pages/TestPage';
import TestExternalPage from './pages/TestExternalPage';
import DirectQRCodePage from './pages/DirectQRCode';
import TossPayment from './pages/Companies/Toss/TossPayment';
import TossResult from './pages/Companies/Toss/TossResult';
import TossPaymentMob from './pages/Companies/Toss/TossPaymentMob';
import PaypalPayment from './pages/Companies/Paypal/PaypalPayment';
import PaypalResult from './pages/Companies/Paypal/PaypalResult';
import PaypalPaymentMob from './pages/Companies/Paypal/PayPalPaymentMob';
import PaypalResultMob from './pages/Companies/Paypal/PaypalResultMob';
import HanaPayment from './pages/Companies/Hana/HanaPayment';
import HanaResult from './pages/Companies/Hana/HanaResult';
import HanaPaymentMob from './pages/Companies/Hana/HanaPaymentMob';
import HanaResultMob from './pages/Companies/Hana/HanaResultMob';
import AlipayPayment from './pages/Companies/Alipay/AlipayPayment';
import AlipayResult from './pages/Companies/Alipay/AlipayResult';
import AlipayResultMob from './pages/Companies/Alipay/AlipayResultMob';
import AlipayPaymentMob from './pages/Companies/Alipay/AlipayPaymentMob';
import IPay88Payment from './pages/Companies/IPay88/IPay88Payment';
import IPay88Result from './pages/Companies/IPay88/IPay88Result';
import IPay88PaymentMob from './pages/Companies/IPay88/IPay88PaymentMob';
import IPay88ResultMob from './pages/Companies/IPay88/IPay88ResultMob';
import EcontextPayment from './pages/Companies/Econtext/EcontextPayment';
import EcontextResult from './pages/Companies/Econtext/EcontextResult';
import EcontextPaymentMob from './pages/Companies/Econtext/EcontextPaymentMob';
import EcontextResultMob from './pages/Companies/Econtext/EcontextResultMob';
import WechatPayment from './pages/Companies/Wechat/WechatPayment';
import WechatPaymentMob from './pages/Companies/Wechat/WechatPaymentMob';
import MobiliansPayment from './pages/Companies/Mobilians/MobiliansPayment';
import MobiliansResult from './pages/Companies/Mobilians/MobiliansResult';
import MobiliansPaymentMob from './pages/Companies/Mobilians/MobiliansPaymentMob';
import MobiliansResultMob from './pages/Companies/Mobilians/MobiliansResultMob';
import WechatResultMob from './pages/Companies/Wechat/WechatResultMob';
import WechatResultWay from './pages/Companies/Wechat/WechatResultWay';
import KCPPayment from './pages/Companies/KCP/KCPPayment';
import KCPResult from './pages/Companies/KCP/KCPResult';
import KCPPaymentMob from './pages/Companies/KCP/KCPPaymentMob';
import KCPResultMob from './pages/Companies/KCP/KCPResultMob';
import TossResultMob from './pages/Companies/Toss/TossResultMob';
import PayversePayment from './pages/Companies/Payverse/PayversePayment';
import PayverseResult from './pages/Companies/Payverse/PayverseResult';
import WechatThrough from './components/OrderPayment/Wechat/WechatThrough';
import PayversePaymentMob from './pages/Companies/Payverse/PayversePaymentMob';
import PayverseResultMob from './pages/Companies/Payverse/PayverseResultMob';
import AmountPage from './pages/Amount';
import ReceiptPage from './pages/Receipt';
import HectoPayment from './pages/Companies/Hecto/HectoPayment';
import HectoResult from './pages/Companies/Hecto/HectoResult';
import HectoPaymentMob from './pages/Companies/Hecto/HectoPaymentMob';
import HectoResultMob from './pages/Companies/Hecto/HectoResultMob';
import EbanxPayment from './pages/Companies/Ebanx/EbanxPayment';
import EbanxResult from './pages/Companies/Ebanx/EbanxResult';
import EbanxPaymentMob from './pages/Companies/Ebanx/EbanxPaymentMob';
import EbanxResultMob from './pages/Companies/Ebanx/EbanxResultMob';
import NuveiPayment from './pages/Companies/Nuvei/NuveiPayment';
import NuveiResult from './pages/Companies/Nuvei/NuveiResult';
import NuveiPaymentMob from './pages/Companies/Nuvei/NuveiPaymentMob';
import NuveiResultMob from './pages/Companies/Nuvei/NuveiResultMob';
import UnivapayPayment from './pages/Companies/Univapay/UnivapayPayment';
import UnivapayResult from './pages/Companies/Univapay/UnivapayResult';
import UnivapayPaymentMob from './pages/Companies/Univapay/UnivapayPaymentMob';
import UnivapayResultMob from './pages/Companies/Univapay/UnivapayResultMob';
//
import OpenUiPage from './pages/OpenUI';
import WechatOAPage from './pages/WechatOA';
import PaymentExpiredPage from './pages/PaymentExpired';

import Keyin from './pages/Keyin';
import Billkey from './pages/BillkeyRegister';
import ShopifyUiPage from './pages/ShopifyUI';
import ShopifyConfirmPage from './pages/ShopifyConfirm';
import ReturnBridgePage from './pages/ReturnBridge';
import ClosePopupPage from './pages/ClosePopup';
import RspPayment from './pages/Companies/Rsp/RspPayment';
import RspResult from './pages/Companies/Rsp/RspResult';
import RspPaymentMob from './pages/Companies/Rsp/RspPaymentMob';
import RspResultMob from './pages/Companies/Rsp/RspResultMob';
import ZalopayPayment from './pages/Companies/Zalopay/ZalopayPayment';
import ZalopayResult from './pages/Companies/Zalopay/ZalopayResult';
import ZalopayPaymentMob from './pages/Companies/Zalopay/ZalopayPaymentMob';
import ZalopayResultMob from './pages/Companies/Zalopay/ZalopayResultMob';
import RequestCompletePage from './pages/RequestComplete';
import ApplePayScreen from './pages/ApplePayScreen';
import ApplePayPayment from './pages/Companies/ApplePay/ApplePayPayment';
import ApplePayResult from './pages/Companies/ApplePay/ApplePayResult';
import ApplePayPaymentMob from './pages/Companies/ApplePay/ApplePayPaymentMob';
import ApplePayResultMob from './pages/Companies/ApplePay/ApplePayResultMob';
import DebianQRPage from './pages/DebiaQR';
import DirectDebiaQRPage from './pages/DirectDebiaQR';
import DirectDebiaQRCodePage from './pages/DirectDebiaQRCode';
import DebiaPayment from './pages/Companies/Debia/DebiaPayment';
import DebiaResultWay from './pages/Companies/Debia/DebiaResultWay';
import DebiaPaymentMob from './pages/Companies/Debia/DebiaPaymentMob';
import DebiaResultMob from './pages/Companies/Debia/DebiaResultMob';

import NicePaymentScreen from './pages/Companies/NicePay/NicePayPayment';
import NicePayResult from './pages/Companies/NicePay/NicePayResult';
import NicePayResultMob from './pages/Companies/NicePay/NicePayResultMob';
import DanalPayment from './pages/Companies/Danal/DanalPayment';
import DanalResult from './pages/Companies/Danal/DanalResult';
import DanalPaymentMob from './pages/Companies/Danal/DanalPaymentMob';
import DanalResultMob from './pages/Companies/Danal/DanalResultMob';

import GooglePayPayment from './pages/Companies/GooglePay/GooglePayPayment';
import GooglePayResult from './pages/Companies/GooglePay/GooglePayResult';
import GooglePayPaymentMob from './pages/Companies/GooglePay/GooglePayPaymentMob';
import GooglePayResultMob from './pages/Companies/GooglePay/GooglePayResultMob';
import GooglePayScreen from './pages/GooglePayScreen';

export function App() {
  const { i18n } = useTranslation();

  React.useEffect(() => {
    function handleContextMenu(e) {
      e.preventDefault();
    }
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.addEventListener('contextmenu', handleContextMenu);
      return () => {
        rootElement.removeEventListener('contextmenu', handleContextMenu);
      };
    }
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* UI용  */}
          <Route path="/" element={<MainScreen />} />
          <Route path="formSubmit" element={<FormSubmit />} />
          <Route path="confirm" element={<ConfirmPage />} />
          <Route path="dataFormSubmit" element={<DataFormSubmitPage />} />
          <Route path="sqr/amount" element={<AmountPage />} />
          <Route path="receipt" element={<ReceiptPage />} />
          <Route path="openui" element={<OpenUiPage />} />
          <Route path="shopifyui" element={<ShopifyUiPage />} />
          <Route path="returnBridge" element={<ReturnBridgePage />} />
          <Route path="applepay/screen" element={<ApplePayScreen />} />
          {/* Direct용  */}
          <Route path="close" element={<ClosePage />} />
          <Route path="closePopup" element={<ClosePopupPage />} />
          <Route path="directResult" element={<DirectResultPage />} />
          <Route path="iframePopup" element={<IframePopupPage />} />
          <Route path="directIframe" element={<DirectIframePage />} />
          <Route path="UiIframe" element={<UIIframePage />} />
          <Route path="directPayment" element={<DirectPaymentPage />} />
          <Route path="directPopup" element={<DirectPopupPage />} />
          <Route path="directEchoQr" element={<DirectEchoQRPage />} />
          <Route path="directPending" element={<DirectPendingPage />} />
          <Route path="directQr" element={<DirectQRPage />} />
          <Route path="DirectQRCode" element={<DirectQRCodePage />} />
          <Route path="directDebiaQr" element={<DirectDebiaQRPage />} />
          <Route path="directDebiaQRCode" element={<DirectDebiaQRCodePage />} />
          <Route element={<Layout />}>
            {/* Layout  UI*/}
            <Route path="payment" element={<PaymentPage />} />
            {/* keyin */}
            <Route path="keyin" element={<Keyin />} />
            {/* billkey */}
            <Route path="billkey" element={<Billkey />} />
            <Route path="paymentExpired" element={<PaymentExpiredPage />} />
            <Route path="success" element={<SuccessPage />} />
            <Route path="requestComplete" element={<RequestCompletePage />} />
            <Route path="decline" element={<DeclinePage />} />
            <Route path="error" element={<ErrorPage />} />
            <Route path="urlError" element={<ReturnUrlErrorPage />} />
            <Route path="processing" element={<ProcessingPage />} />
            <Route path="pending" element={<PendingPage />} />
            <Route path="vbankPending" element={<VbankPendingPage />} />
            <Route path="received" element={<ReceivedPage />} />
            <Route path="failed" element={<FailedPage />} />
            <Route path="cancel" element={<CancelPage />} />
            <Route path="shopifyConfirm" element={<ShopifyConfirmPage />} />

            <Route
              path="domesticCardError"
              element={<DomesticCardErrorPage />}
            />
            <Route path="wechatOpen" element={<WechatOpen />} />
            <Route path="wechatOA" element={<WechatOAPage />} />
            <Route path="wechatResult" element={<WechatResult />} />
            <Route path="ResultConfirm" element={<ResultConfirm />} />
            <Route path="Redirect" element={<RedirectPage />} />
            <Route path="QRCode" element={<QRPage />} />
            <Route path="debiaQr" element={<DebianQRPage />} />
            <Route path="EchoQR" element={<EchoQRPage />} />
          </Route>
          <Route path="/pc/tosspay/payment" element={<TossPayment />} />
          <Route path="/pc/tosspay/result" element={<TossResult />} />
          <Route path="/mobile/tosspay/payment" element={<TossPaymentMob />} />
          <Route path="/mobile/tosspay/result" element={<TossResultMob />} />
          <Route path="/pc/paypal/payment" element={<PaypalPayment />} />
          <Route path="/pc/paypal/result" element={<PaypalResult />} />
          <Route path="/mobile/paypal/payment" element={<PaypalPaymentMob />} />
          <Route path="/mobile/paypal/result" element={<PaypalResultMob />} />
          <Route path="/pc/hana/payment" element={<HanaPayment />} />
          <Route path="/pc/hana/result" element={<HanaResult />} />
          <Route path="/mobile/hana/payment" element={<HanaPaymentMob />} />
          <Route path="/mobile/hana/result" element={<HanaResultMob />} />
          <Route path="/pc/alipay/payment" element={<AlipayPayment />} />
          <Route path="/pc/alipay/result" element={<AlipayResult />} />
          <Route path="/mobile/alipay/payment" element={<AlipayPaymentMob />} />
          <Route path="/mobile/alipay/result" element={<AlipayResultMob />} />
          <Route path="/pc/ipay88/payment" element={<IPay88Payment />} />
          <Route path="/pc/ipay88/result" element={<IPay88Result />} />
          <Route path="/mobile/ipay88/payment" element={<IPay88PaymentMob />} />
          <Route path="/mobile/ipay88/result" element={<IPay88ResultMob />} />
          <Route path="/pc/econtext/payment" element={<EcontextPayment />} />
          <Route path="/pc/econtext/result" element={<EcontextResult />} />
          <Route
            path="/mobile/econtext/payment"
            element={<EcontextPaymentMob />}
          />
          <Route
            path="/mobile/econtext/result"
            element={<EcontextResultMob />}
          />
          <Route path="/pc/wechat/payment" element={<WechatPayment />} />
          <Route path="/pc/wechat/result" element={<WechatResultWay />} />
          <Route path="/mobile/wechat/payment" element={<WechatPaymentMob />} />
          <Route path="/mobile/wechat/result" element={<WechatResultMob />} />
          <Route path="wechat/through" element={<WechatThrough />} />
          <Route path="/pc/debia/payment" element={<DebiaPayment />} />
          <Route path="/pc/debia/result" element={<DebiaResultWay />} />
          <Route path="/mobile/debia/payment" element={<DebiaPaymentMob />} />
          <Route path="/mobile/debia/result" element={<DebiaResultMob />} />
          <Route path="/pc/mobilians/payment" element={<MobiliansPayment />} />
          <Route path="/pc/mobilians/result" element={<MobiliansResult />} />
          <Route
            path="/mobile/mobilians/payment"
            element={<MobiliansPaymentMob />}
          />
          <Route
            path="/mobile/mobilians/result"
            element={<MobiliansResultMob />}
          />
          <Route path="/pc/kcp/payment" element={<KCPPayment />} />
          <Route path="/pc/kcp/result" element={<KCPResult />} />
          <Route path="/mobile/kcp/payment" element={<KCPPaymentMob />} />
          <Route path="/mobile/kcp/result" element={<KCPResultMob />} />
          <Route path="/pc/payverse/payment" element={<PayversePayment />} />
          <Route path="/pc/payverse/result" element={<PayverseResult />} />
          <Route
            path="/mobile/payverse/payment"
            element={<PayversePaymentMob />}
          />
          <Route
            path="/mobile/payverse/result"
            element={<PayverseResultMob />}
          />
          <Route path="/pc/hecto/payment" element={<HectoPayment />} />
          <Route path="/pc/hecto/result" element={<HectoResult />} />
          <Route path="/mobile/hecto/payment" element={<HectoPaymentMob />} />
          <Route path="/mobile/hecto/result" element={<HectoResultMob />} />
          <Route path="/pc/danal/payment" element={<DanalPayment />} />
          <Route path="/pc/danal/result" element={<DanalResult />} />
          <Route path="/mobile/danal/payment" element={<DanalPaymentMob />} />
          <Route path="/mobile/danal/result" element={<DanalResultMob />} />
          <Route path="/pc/ebanx/payment" element={<EbanxPayment />} />
          <Route path="/pc/ebanx/result" element={<EbanxResult />} />
          <Route path="/mobile/ebanx/payment" element={<EbanxPaymentMob />} />
          <Route path="/mobile/ebanx/result" element={<EbanxResultMob />} />
          <Route path="/pc/nuvei/payment" element={<NuveiPayment />} />
          <Route path="/pc/nuvei/result" element={<NuveiResult />} />
          <Route path="/mobile/nuvei/payment" element={<NuveiPaymentMob />} />
          <Route path="/mobile/nuvei/result" element={<NuveiResultMob />} />
          <Route path="/pc/univapay/payment" element={<UnivapayPayment />} />
          <Route path="/pc/univapay/result" element={<UnivapayResult />} />
          <Route
            path="/mobile/univapay/payment"
            element={<UnivapayPaymentMob />}
          />
          <Route
            path="/mobile/univapay/result"
            element={<UnivapayResultMob />}
          />
          <Route path="/pc/rsp/payment" element={<RspPayment />} />
          <Route path="/pc/rsp/result" element={<RspResult />} />
          <Route path="/mobile/rsp/payment" element={<RspPaymentMob />} />
          <Route path="/mobile/rsp/result" element={<RspResultMob />} />
          <Route path="/pc/zalopay/payment" element={<ZalopayPayment />} />
          <Route path="/pc/zalopay/result" element={<ZalopayResult />} />
          <Route
            path="/mobile/zalopay/payment"
            element={<ZalopayPaymentMob />}
          />
          <Route path="/mobile/zalopay/result" element={<ZalopayResultMob />} />
          <Route path="/pc/applepay/payment" element={<ApplePayPayment />} />
          <Route path="/pc/applepay/result" element={<ApplePayResult />} />
          <Route
            path="/mobile/applepay/payment"
            element={<ApplePayPaymentMob />}
          />
          <Route
            path="/mobile/applepay/result"
            element={<ApplePayResultMob />}
          />
          {/* 구글페이 */}
          <Route path="/googlepay/screen" element={<GooglePayScreen />} />
          <Route path="/pc/googlepay/payment" element={<GooglePayPayment />} />
          <Route path="/pc/googlepay/result" element={<GooglePayResult />} />
          <Route
            path="/mobile/googlepay/payment"
            element={<GooglePayPaymentMob />}
          />
          <Route
            path="/mobile/googlepay/result"
            element={<GooglePayResultMob />}
          />
          {/* 나이스 */}
          <Route path="/nice/screen" element={<NicePaymentScreen />} />
          <Route path="/pc/nice/result" element={<NicePayResult />} />{' '}
          <Route path="/mobile/nice/result" element={<NicePayResultMob />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <GlobalStyle />
      </BrowserRouter>
    </div>
  );
}
